import React, { useState } from "react";
import Dropdown, { DropdownProps } from "../../Dropdown";
import { RowSelectionActionOn } from "../index";

export interface TableBulkActionsProps {
  actionsDropdownProps?: DropdownProps;
  onRowSelectionAction?: (selectedValue: string | number, action: RowSelectionActionOn) => void;
  selectItemsLength: number;
  dataSourceLength: number;
  clearSelections: () => void;
  allowAllSelection?: boolean;
  totalRows?: number;
}

const TableBulkActions: React.FC<TableBulkActionsProps> = ({
  actionsDropdownProps,
  onRowSelectionAction,
  totalRows,
  allowAllSelection,
  selectItemsLength,
  dataSourceLength,
  clearSelections
}) => {
  const [rowSelectionActionsOn, setRowSelectionActionsOn] =
    useState<RowSelectionActionOn>("selected");

  const onChangeForActions = (selectedValue: string | number) => {
    if (selectItemsLength > 0) {
      onRowSelectionAction && onRowSelectionAction(selectedValue, rowSelectionActionsOn);
    }
  };

  return (
    <>
      {selectItemsLength > 0 && (
        <div className="flex space-x-2 items-center z-20">
          <div className="flex-grow flex items-center justify-center space-x-2 bg-yellow-50 p-2">
            <div>
              {rowSelectionActionsOn === "all" ? totalRows : selectItemsLength} rows selected.
            </div>
            {allowAllSelection &&
              rowSelectionActionsOn !== "all" &&
              selectItemsLength === dataSourceLength && (
                <>
                  <div>|</div>
                  <button className="text-blue-600" onClick={() => setRowSelectionActionsOn("all")}>
                    {totalRows ? `Select all ${totalRows} rows` : "Select all rows"}
                  </button>
                </>
              )}
            <div>|</div>
            <button className="text-blue-600" onClick={clearSelections}>
              Clear
            </button>
          </div>
          {actionsDropdownProps && (
            <Dropdown {...actionsDropdownProps} onChange={onChangeForActions} />
          )}
        </div>
      )}
    </>
  );
};

export default TableBulkActions;
